import { create } from 'zustand';

export interface CustomerProfile {
  id: string;
  first_name: string | null;
  last_name: string | null;
  full_name: string;
  phone: string | null;
  email: string | null;
}

const REFRESH_KEY = 'totem_portal_refresh';

export function getStoredRefresh(): string | null {
  try {
    return localStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

export function setStoredRefresh(token: string | null): void {
  try {
    if (token) localStorage.setItem(REFRESH_KEY, token);
    else localStorage.removeItem(REFRESH_KEY);
  } catch {
    /* storage unavailable */
  }
}

interface CustomerAuthState {
  // Access token lives in memory only; the rotating refresh token is in localStorage.
  access_token: string | null;
  customer: CustomerProfile | null;
  setSession: (access_token: string, customer: CustomerProfile) => void;
  setCustomer: (customer: CustomerProfile) => void;
  clear: () => void;
}

export const useCustomerAuthStore = create<CustomerAuthState>((set) => ({
  access_token: null,
  customer: null,
  setSession: (access_token, customer) => set({ access_token, customer }),
  setCustomer: (customer) => set({ customer }),
  clear: () => {
    setStoredRefresh(null);
    set({ access_token: null, customer: null });
  },
}));
